const rankingItems = [
  { rank: 1, title: '长安风云录', tag: '古装传奇', hot: '9.8', trend: 'up', desc: '大唐权谋史诗，演技派全员飙戏' },
  { rank: 2, title: '遇见你的那天', tag: '都市情感', hot: '9.6', trend: 'up', desc: '暖心治愈都市爱情，口碑持续走高' },
  { rank: 3, title: '迷雾追踪', tag: '悬疑刑侦', hot: '9.5', trend: 'up', desc: '烧脑推理全程高能，反转再反转' },
  { rank: 4, title: '江湖夜雨', tag: '武侠江湖', hot: '9.3', trend: 'stable', desc: '新派武侠诚意之作，打戏行云流水' },
  { rank: 5, title: '星光之恋', tag: '青春偶像', hot: '9.1', trend: 'up', desc: '甜度超标的青春偶像剧，颜值在线' },
];

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  stable: 'ri-subtract-line text-foreground-400',
  down: 'ri-arrow-down-line text-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热播榜单</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时更新全网热播电视剧排名，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 border-b border-background-200/60 last:border-0 hover:bg-background-50/80 transition-colors duration-200 cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center font-bold text-sm font-heading ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                  <h3 className="text-base font-semibold text-foreground-950 font-heading whitespace-nowrap group-hover:text-primary-500 transition-colors">{item.title}</h3>
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-sm text-foreground-500">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-3">
                <div className="flex items-center gap-1">
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                  <span className="text-sm font-bold text-foreground-950 font-heading">{item.hot}</span>
                </div>
                <i className={trendIcon[item.trend] + ' text-sm'}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}